import { render } from "./CardMenu.vue?vue&type=template&id=bbb4a8b2&scoped=true"
import script from "./CardMenu.vue?vue&type=script&lang=js"
export * from "./CardMenu.vue?vue&type=script&lang=js"

import "@/Common/Styles/nftCard.scss?vue&type=style&index=0&id=bbb4a8b2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbb4a8b2"]])

export default __exports__